module.exports = __webpack_public_path__ + "img/hxjzg.16dcd9e8.png";